import StyledApiErrorMessage from './StyledApiErrorMessage'

export default StyledApiErrorMessage
